import React from "react";
import SkeletonTripCard from "./SkeletonTripCard";
import { Stack } from "@mui/material";

const SkeletonTripList = ({ count = 3, width = "100%" }) => {
  return (
    <Stack spacing={2} sx={{ width }}>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonTripCard key={index} />
      ))}
    </Stack>
  );
};

export default SkeletonTripList;
